// @flow

const isEnabled = (): boolean => typeof mixpanel !== 'undefined';

export const resetUser = () => {
  if (isEnabled()) {
    mixpanel.reset();
  }
};

export const register = (properties: Object, days?: number) => {
  if (isEnabled()) {
    mixpanel.register(properties, days);
  }
};

export const registerOnce = (properties: Object) => {
  if (isEnabled()) {
    mixpanel.register_once(properties);
  }
};

export const unregister = (property: string) => {
  if (isEnabled()) {
    mixpanel.unregister(property);
  }
};

export const track = (
  eventName: string,
  properties: Object,
  callback: ?Function
) => {
  if (isEnabled()) {
    mixpanel.track(eventName, properties, callback);
    return;
  }

  // If mixpanel is disabled, manually invoke callback
  if (callback) callback();
};

// only use for external links, not with react-router
export const trackLinks = (
  el: Element,
  eventName: string,
  properties: Object
) => {
  if (isEnabled()) {
    mixpanel.track_links(el, eventName, properties);
  }
};
